export default __webpack_public_path__ + "static/media/burger.4775a14a.svg";